import { Link } from "react-router-dom";
import {
  Droplets, Zap, Paintbrush, Hammer, Snowflake, Building2, Sparkles, Bug, ShieldCheck, Sofa, ArrowRight,
} from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

const CATEGORIES = [
  { Icon: Droplets, title: "Plumbing", items: "Leakage · taps · flush systems · water lines · drainage · pumps" },
  { Icon: Zap, title: "Electrical", items: "Switches · sockets · lights · fans · MCB issues · minor repairs" },
  { Icon: Paintbrush, title: "Painting", items: "Full painting · touch-ups · wall repair · post-vacancy repainting" },
  { Icon: Hammer, title: "Carpentry & Woodwork", items: "Doors · locks · hinges · cabinets · wardrobes · kitchen repairs" },
  { Icon: Snowflake, title: "AC & Appliances", items: "AC servicing · refrigerator · washing machine · geyser · kitchen appliances" },
  { Icon: Building2, title: "Civil Works", items: "Tile repairs · wall repairs · minor masonry · waterproofing · seepage" },
  { Icon: Sparkles, title: "Cleaning", items: "Regular · deep · move-out · move-in · bathroom · kitchen · balcony" },
  { Icon: Bug, title: "Pest Control", items: "Scheduled treatments before handover and on demand" },
  { Icon: ShieldCheck, title: "Security & Access", items: "Access coordination for vendors, tenants and society staff" },
  { Icon: Sofa, title: "Interior Works", items: "Design · renovation · modular · false ceiling · flooring · execution" },
];

export const Maintenance = () => (
  <section className="relative overflow-hidden bg-navy-900 py-24 sm:py-32" data-testid="maintenance-section">
    <div
      className="pointer-events-none absolute inset-0"
      style={{ background: "radial-gradient(ellipse 45% 40% at 95% 100%, rgba(201,162,39,0.1), transparent 60%)" }}
      aria-hidden="true"
    />
    <div className="container-site relative">
      <SectionHeading
        chapter="05"
        eyebrow="Complete Property Maintenance"
        dark
        title="One Contact for Almost Everything Your Property Needs."
        copy="Stop coordinating ten different vendors from another country. Tell us once — we coordinate, supervise and show you the finished work."
      />

      <Stagger className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" gap={0.06}>
        {CATEGORIES.map(({ Icon, title, items }) => (
          <StaggerItem key={title}>
            <div className="h-full rounded-2xl border border-white/10 bg-white/[0.04] p-6 transition-[border-color,background-color] duration-300 hover:border-gold-500/40 hover:bg-white/[0.07]" data-testid={`maintenance-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <Icon className="h-5 w-5 text-gold-400" />
              <h3 className="mt-4 font-display text-base font-extrabold tracking-tight text-white">{title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-white/55">{items}</p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-6">
          <p className="max-w-xl text-xs leading-relaxed text-white/45">
            Larger projects are coordinated through the group's professional execution network. No unnecessary
            work without owner approval — except genuine emergencies where immediate action prevents further damage.
          </p>
          <Link to="/property-maintenance" className="btn-gold" data-testid="maintenance-cta">
            Request Maintenance Support <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
